import { createContext, useContext, useEffect, useState } from "react";
import { en } from "@/content/en";
import { es } from "@/content/es";

const dict = { en, es };
const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("cyf-lang") || "en");
  useEffect(() => {
    localStorage.setItem("cyf-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
